(function () {
  "use strict";

  var LETTER_RUNES = {
    A: "ᚨ", B: "ᛒ", C: "ᚲ", D: "ᛞ", E: "ᛖ", F: "ᚠ", G: "ᚷ", H: "ᚺ",
    I: "ᛁ", J: "ᛃ", K: "ᚲ", L: "ᛚ", M: "ᛗ", N: "ᚾ", O: "ᛟ", P: "ᛈ",
    Q: "ᚲᚹ", R: "ᚱ", S: "ᛊ", T: "ᛏ", U: "ᚢ", V: "ᚹ", W: "ᚹ", X: "ᚲᛊ",
    Y: "ᛁ", Z: "ᛉ", "Æ": "ᛇ", "Ø": "ᛟ", "Å": "ᚨ", "Þ": "ᚦ", "Ð": "ᛞ",
    "Œ": "ᛟᛖ", "Ł": "ᛚ"
  };
  var COMBINATION_RUNES = {
    TH: "ᚦ", NG: "ᛜ", PH: "ᚠ", QU: "ᚲᚹ", SH: "ᛊᚺ", CH: "ᚲ", CK: "ᚲ", AA: "ᚨ"
  };
  var SEPARATORS = { " ": true, "-": true, "'": true, "’": true };

  function baseLetter(ch) {
    return ch.normalize("NFD").replace(/[\u0300-\u036f]/g, "").charAt(0);
  }

  function encodeName(value) {
  /* fornvegr-elder-futhark-2026-10-02 (v2). Mirror of scripts/rune_transliteration.py MAPPING_V2. */
  var L = {A:'ᚨ',B:'ᛒ',C:'ᚲ',D:'ᛞ',E:'ᛖ',F:'ᚠ',G:'ᚷ',H:'ᚺ',I:'ᛁ',J:'ᛃ',K:'ᚲ',L:'ᛚ',M:'ᛗ',N:'ᚾ',O:'ᛟ',P:'ᛈ',Q:'ᚲᚹ',R:'ᚱ',S:'ᛊ',T:'ᛏ',U:'ᚢ',V:'ᚹ',W:'ᚹ',X:'ᚲᛊ',Y:'ᛁ',Z:'ᛉ','Æ':'ᛇ','Ø':'ᛟ','Å':'ᚨ','Þ':'ᚦ','Ð':'ᛞ','Œ':'ᛟᛖ','Ł':'ᛚ'};
  var C2 = {TH:'ᚦ',NG:'ᛜ',PH:'ᚠ',QU:'ᚲᚹ',SH:'ᛊᚺ',CH:'ᚲ',CK:'ᚲ',AA:'ᚨ'};
  var SEP = {' ':1,'-':1,"'":1,'’':1};
  var VOW = 'AEIOUYÆØÅ';
  var u = String(value || '').normalize('NFC').toUpperCase(), out = '', i = 0;
  while (i < u.length) {
    var ch = u.charAt(i), nx = u.charAt(i + 1);
    if (SEP[ch]) { out += ' '; i += 1; continue; }
    var ws = i === 0 || !!SEP[u.charAt(i - 1)];
    if (u.substr(i, 3) === 'TTH') { out += 'ᚦ'; i += 3; continue; }
    if (ch === 'C' && (nx === 'E' || nx === 'I' || nx === 'Y')) { out += 'ᛊ'; i += 1; continue; }
    if (ch === 'Ç') { out += 'ᛊ'; i += 1; continue; }
    if (ch === 'Y' && ws && nx && VOW.indexOf(nx) !== -1 && nx !== 'Y') { out += 'ᛃ'; i += 1; continue; }
    var pr = u.slice(i, i + 2);
    if (C2[pr]) { out += C2[pr]; i += 2; continue; }
    if (L[ch]) { out += L[ch]; i += 1; continue; }
    var b = ch.normalize('NFD').replace(/[\u0300-\u036f]/g, '').charAt(0);
    if (L[b]) out += L[b];
    i += 1;
  }
  /* 2026-10-19 double-rune fix: identical runes next to each other in one word are carved once (Olsson -> ᛟᛚᛊᛟᚾ). Runs after letter-to-rune mapping, so CK/CC/X+S and similar also collapse. Names only; date ciphers are not touched. */
  return out.trim().replace(/([\u16A0-\u16FF])\1+/g, '$1');
}

  /* 2026-10-19 rune fit: keep the rune row on one line by shrinking the glyphs to the card width.
     Only when that would go below MIN_RUNE_PX does it wrap, at word spaces, with each word fitted. */
  var MIN_RUNE_PX = 30;
  function fitRunes(node) {
    if (!node) return;
    node.style.fontSize = "";
    node.classList.remove("is-wrapped");
    var text = node.textContent;
    var avail = node.clientWidth;
    if (!text || !avail) return;
    var base = parseFloat(window.getComputedStyle(node).fontSize) || 48;
    var need = node.scrollWidth;
    if (need <= avail + 1) return;
    var size = Math.floor(base * (avail / need) * 0.97);
    if (size >= MIN_RUNE_PX) { node.style.fontSize = size + "px"; return; }
    node.classList.add("is-wrapped");
    var probe = document.createElement("span");
    probe.style.cssText = "position:absolute;visibility:hidden;white-space:nowrap;left:-9999px;top:0";
    node.appendChild(probe);
    var widest = 0;
    text.split(" ").forEach(function (word) {
      probe.textContent = word;
      widest = Math.max(widest, probe.getBoundingClientRect().width);
    });
    node.removeChild(probe);
    var wrapped = widest > avail ? Math.floor(base * (avail / widest) * 0.97) : base;
    node.style.fontSize = Math.max(Math.min(wrapped, base), 22) + "px";
  }

  function track(eventName, params) {
    var payload = Object.assign({ event_category: "organic_tool" }, params || {});
    if (typeof window.gtag === "function") window.gtag("event", eventName, payload);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, payload));
  }

  function i18n(node, key, fallback) {
    var holder = node && node.closest ? node.closest("[data-fornvegr-name-transliterator]") : null;
    var value = holder ? holder.getAttribute("data-i18n-" + key) : "";
    return value || fallback;
  }

  function drawShareCard(canvas, name, runes) {
    var ctx = canvas.getContext("2d");
    canvas.width = 1080;
    canvas.height = 1350;
    ctx.fillStyle = "#eee9df";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.strokeStyle = "#332f2a";
    ctx.lineWidth = 2;
    ctx.strokeRect(72, 72, 936, 1206);
    ctx.fillStyle = "#332f2a";
    ctx.textAlign = "center";
    ctx.font = "36px Georgia, serif";
    ctx.fillText(i18n(canvas, "card-title", "MY NAME IN ELDER FUTHARK"), 540, 190);
    ctx.font = "64px Georgia, serif";
    ctx.fillText(name.toUpperCase(), 540, 420);
    ctx.font = "86px 'Noto Sans Runic', 'Segoe UI Symbol', sans-serif";
    var words = runes.split(" ");
    var lines = [];
    var current = "";
    words.forEach(function (word) {
      var attempt = current ? current + " " + word : word;
      if (ctx.measureText(attempt).width > 880 && current) {
        lines.push(current);
        current = word;
      } else {
        current = attempt;
      }
    });
    if (current) lines.push(current);
    lines.slice(0, 3).forEach(function (line, index) {
      ctx.fillText(line, 540, 650 + (index * 120));
    });
    ctx.font = "30px Georgia, serif";
    ctx.fillText(i18n(canvas, "card-note", "Transliterated by sound, not translated for meaning."), 540, 1080);
    ctx.font = "34px Georgia, serif";
    ctx.fillText(i18n(canvas, "card-domain", "FORNVEGR.COM"), 540, 1190);
  }

  function init(root) {
    var input = root.querySelector("[data-name-input]");
    var form = root.querySelector("[data-name-form]");
    var result = root.querySelector("[data-result]");
    var runesNode = root.querySelector("[data-runes]");
    var latinNode = root.querySelector("[data-latin]");
    var shareButton = root.querySelector("[data-share]");
    var productLink = root.querySelector("[data-product-link]");
    var canvas = root.querySelector("[data-share-canvas]");
    var emailForm = root.querySelector(".fornvegr-name-tool__email-form");
    var emailSuccess = root.querySelector("[data-email-success]");
    var emailError = root.querySelector("[data-email-error]");
    var lastCompletedName = "";
    var ctaTemplate = productLink ? productLink.getAttribute("data-cta-template") : "";
    var ctaDefaultName = (productLink && productLink.getAttribute("data-cta-default-name")) || "Emma";

    function render(trackCompletion) {
      var name = input.value.trim();
      var runes = encodeName(name);
      result.hidden = !runes;
      runesNode.textContent = runes;
      fitRunes(runesNode);
      latinNode.textContent = name;
      shareButton.disabled = !runes;
      if (ctaTemplate) {
        // 2026-10-19 priced CTA: the button names what you get, live as you type.
        productLink.textContent = ctaTemplate.split("{name}").join(name.replace(/\s+/g, " ") || ctaDefaultName);
      }
      if (trackCompletion && runes && name !== lastCompletedName) {
        lastCompletedName = name;
        track("name_transliterator_complete", { name_length: name.length });
      }
      return { name: name, runes: runes };
    }

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      render(true);
    });
    input.addEventListener("input", function () {
      render(false);
    });
    productLink.addEventListener("click", function () {
      var value = render(false);
      try {
        // The storefront CTA is same-origin; sessionStorage expires with the tab.
        if (value.runes && new URL(productLink.href).origin === location.origin) {
          sessionStorage.setItem("fornvegr:name-print-handoff:v1", JSON.stringify({
            name: value.name,
            mapping: "fornvegr-elder-futhark-2026-10-19",
            createdAt: Date.now()
          }));
        }
      } catch (error) { /* Storage blocked: leave navigation and input usable. */ }
      track("name_transliterator_product_click", { link_url: productLink.href });
    });
    shareButton.addEventListener("click", function () {
      var value = render(false);
      if (!value.runes) return;
      drawShareCard(canvas, value.name, value.runes);
      canvas.toBlob(function (blob) {
        if (!blob) return;
        var file = new File([blob], "my-name-in-elder-futhark.png", { type: "image/png" });
        if (navigator.canShare && navigator.canShare({ files: [file] })) {
          navigator.share({
            title: i18n(root, "share-title", "My name in Elder Futhark"),
            text: i18n(root, "share-text", "{name} in Elder Futhark, transliterated by Fornvegr.").replace("{name}", value.name),
            files: [file]
          }).then(function () {
            track("name_transliterator_share", { method: "native" });
          }).catch(function () {});
        } else {
          var link = document.createElement("a");
          link.download = file.name;
          link.href = URL.createObjectURL(blob);
          link.click();
          window.setTimeout(function () { URL.revokeObjectURL(link.href); }, 1000);
          track("name_transliterator_share", { method: "download" });
        }
      }, "image/png");
    });

    if (emailForm) {
      emailForm.addEventListener("submit", function (event) {
        event.preventDefault();
        var submitButton = emailForm.querySelector("button[type='submit']");
        var emailInput = emailForm.querySelector("input[type='email']");
        var companyId = emailForm.getAttribute("data-klaviyo-company-id");
        var listId = emailForm.getAttribute("data-klaviyo-list-id");
        if (!emailInput || !companyId || !listId) return;
        if (submitButton) submitButton.disabled = true;
        if (emailError) emailError.hidden = true;
        track("name_transliterator_email_submit", { consent_context: "name_tool_guide" });
        fetch("https://a.klaviyo.com/client/subscriptions?company_id=" + encodeURIComponent(companyId), {
          method: "POST",
          headers: {
            Accept: "application/vnd.api+json",
            "Content-Type": "application/vnd.api+json",
            Revision: "2026-07-15"
          },
          body: JSON.stringify({
            data: {
              type: "subscription",
              attributes: {
                custom_source: "Fornvegr name tool guide",
                profile: {
                  data: {
                    type: "profile",
                    attributes: {
                      email: emailInput.value,
                      properties: { lead_source: "name_tool_guide" },
                      subscriptions: {
                        email: { marketing: { consent: "SUBSCRIBED" } }
                      }
                    }
                  }
                }
              },
              relationships: {
                list: { data: { type: "list", id: listId } }
              }
            }
          })
        }).then(function (response) {
          if (!response.ok) throw new Error("Subscription request failed");
          emailForm.hidden = true;
          if (emailSuccess) emailSuccess.hidden = false;
          track("name_transliterator_email_success", { consent_context: "name_tool_guide" });
        }).catch(function () {
          if (submitButton) submitButton.disabled = false;
          if (emailError) {
            emailError.textContent = i18n(root, "email-error", "We could not save that address. Please try again.");
            emailError.hidden = false;
          }
          track("name_transliterator_email_error", { consent_context: "name_tool_guide" });
        });
      });
    }

    var refitTimer;
    window.addEventListener("resize", function () {
      window.clearTimeout(refitTimer);
      refitTimer = window.setTimeout(function () { if (!result.hidden) fitRunes(runesNode); }, 100);
    });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { if (!result.hidden) fitRunes(runesNode); });
    }

    track("name_transliterator_view");
  }

  window.FornvegrNameTransliterator = {
    encodeName: encodeName,
    init: init
  };

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-fornvegr-name-transliterator]").forEach(init);
  });
})();
